import { render, staticRenderFns } from "./transferCom.vue?vue&type=template&id=54ce9f33&scoped=true&"
import script from "./transferCom.vue?vue&type=script&lang=js&"
export * from "./transferCom.vue?vue&type=script&lang=js&"
import style0 from "./transferCom.vue?vue&type=style&index=0&id=54ce9f33&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ce9f33",
  null
  
)

component.options.__file = "transferCom.vue"
export default component.exports